import { Section, Container, Private } from "./styles"
import arrayProjects from "./arrayProjects"

export default function Projects(props) {

  return (
    <Section id="projects">
      <h2>Meus projetos</h2>

      <Container>



        {arrayProjects.map(project => <div key={project.src}>
          <a
            href={project.href}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={project.src}
              alt={project.alt}
            />
          </a>

          {project.button.private ? <Private>Privado</Private>
            : <a
              href={project.button.href}
              target="_blank"
              rel="noreferrer"
            >
              <button>
                GitHub
              </button>
            </a>
          }

        </div>
        )}

      </Container>
      
      <a
        href="https://github.com/WellingtonEduardo"
        target="_blank"
        rel="noreferrer"
      >
        <button >Abrir Github</button>
      </a>
    </Section>
  );
}
